export default "__VITE_ASSET__DsGGSxtp__"